var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-login[data-v-a4b17b2a]{background:url(" + escape(require("../../assets/login/login_img.png")) + ") no-repeat 50%;background-size:cover;height:100vh;margin:0}[data-v-a4b17b2a] .autofill-fix.v-text-field .v-label{-webkit-transform:translateY(-18px) scale(.75);transform:translateY(-18px) scale(.75)}", ""]);

// exports
